export default {
    Divider: {
        baseStyle: {},
        sizes: {},
        variants: {
            dashed: {
                borderStyle: "dashed",
            },
            default: {
                borderBottom: ({ colors }) => `1px solid ${colors.secondary["50"]}`
            }
        },
        defaultProps: {
            variant: "default"
        },
    }
};

